/* eslint-disable */
const { localStorage, sessionStorage } = window;

const reducer = (state, action) => {
  const { type } = action;

  switch (type) {
    case 'sample-sale-success': {
      return {
        ...state,
        isSampleSaleAuthenticated: true,
        superSecret: action.payload
      };
    }
    case 'login-success': {
      const { payload } = action;
      sessionStorage.setItem('bbw-session', 'true');
      localStorage.setItem('bbw-tokens', JSON.stringify(payload));

      return {
        ...payload,
        isAuthenticated: true
      };
    }
    case 'auth-challenge': {
      const { payload } = action;

      return {
        ...payload,
        isAuthenticated: false
      };
    }
    case 'auth-reset': {
      sessionStorage.removeItem('bbw-session');
      localStorage.removeItem('bbw-tokens');

      return {
        isAuthenticated: false
      };
    }
    default:
      return state;
  }
};

export default reducer;
